import React, { Component } from 'react';
import { Card } from 'components';
import styled from '@emotion/styled';
import { Colors, device, SvgWrapper, PrimaryButton } from 'utils';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { ProjectsActions } from 'redux/actions';
import { Spin } from 'antd';
import PropTypes from 'prop-types';
import { SadFace } from 'images';
import ExternalLink from 'components/ExternalLink/ExternalLink';
import { projectsServices } from 'services';
import brandRoles from 'utils/brandRoles';
import UpdateMailToggle from './UpdateMailToggle';
import ConfirmModal from './ConfirmModal';

const SupportProjectWrapper = styled.div`
  margin-bottom: 35px;
  .link {
    text-align: center;
    a {
      background: ${Colors.secondaryColor};
      border: 1px solid ${Colors.secondaryColor};
      color: ${Colors.white};
      text-align: center;
      border-radius: 12px;
      cursor: pointer;
      margin-bottom: 20px;
      padding: 15px 20px;
      min-width: 200px;
      font-size: 18px;

      &:hover {
        background: ${Colors.transparent};
        color: ${Colors.secondaryColor};
      }
      @media ${device.allMobile} {
        font-size: 16px;
      }
    }
  }
`;
const CardsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 2%;
  width: 100%;
  margin-bottom: 20px;
  .liked-item {
    width: 32%;
    display: flex;
    flex-direction: column;
    display: inline-block;
    text-align: center;
    margin-bottom: 14px;
    @media ${device.allMobile} {
      width: 100%;
      margin: auto;
      margin-bottom: 20px;
    }
    @media (max-width: 1340px) {
      width: 48%;
    }
    @media (max-width: 1140px) {
      width: 100%;
    }
    @media (max-width: 1025px) {
      width: 48%;
    }
    @media (max-width: 600px) {
      width: 100%;
    }
  }
`;

const MailNotice = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px 24px;
  margin: 0 0 16px;
  padding: 16px;
  border: 1px solid #e9eaeb;
  border-radius: 10px;
  background: #fafafa;
  font-family: Inter, sans-serif;
  font-size: 14px;
  line-height: 21px;
  color: #414651;

  p {
    flex: 1 1 280px;
    margin: 0;
  }

  button {
    margin-bottom: 0;
  }
`;

const MailNote = styled.p`
  margin: 0 0 16px;
  font-family: Inter, sans-serif;
  font-size: 14px;
  line-height: 21px;
  color: ${brandRoles.neutral700};

  a {
    color: ${brandRoles.linkText};
    text-decoration: underline;
  }
`;

const SadFaceWrapper = styled.div`
  text-align: center;
  margin: 25px auto;
`;
class LikedProjects extends Component {
  state = {
    // Projekte, fuer die der Nutzer keine Update-Mails will
    unsubscribedIds: [],
    unsubscribedAll: false,
    mailError: false,
    confirmResubscribe: false,
    resubscribing: false,
    resubscribeError: false,
  };

  componentDidMount() {
    const { getMyLikedProjects } = this.props;
    getMyLikedProjects();
    projectsServices
      .getUpdateSubscriptions()
      .then((res) => this.applySubscriptions(res))
      .catch(() => {});
  }

  applySubscriptions = (res) => {
    if (!res) return;
    this.setState({
      unsubscribedIds: res.unsubscribed_project_ids || [],
      unsubscribedAll: !!res.unsubscribed_all,
    });
  };

  resubscribeAll = () => {
    this.setState({
      confirmResubscribe: false,
      resubscribing: true,
      resubscribeError: false,
    });
    projectsServices
      .resubscribeAllUpdates()
      .then((res) => this.applySubscriptions(res))
      .catch(() => this.setState({ resubscribeError: true }))
      .finally(() => this.setState({ resubscribing: false }));
  };

  toggleMail = (projectId, receive) => {
    const previous = this.state.unsubscribedIds;
    // sofort anzeigen, bei Fehler zuruecksetzen
    this.setState({
      mailError: false,
      unsubscribedIds: receive
        ? previous.filter((id) => id !== projectId)
        : [...previous, projectId],
    });
    projectsServices
      .setUpdateSubscription(projectId, receive)
      .then((res) => this.applySubscriptions(res))
      .catch(() => this.setState({ unsubscribedIds: previous, mailError: true }));
  };
  static propTypes = {
    projects: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired,
    errors: PropTypes.object.isRequired,
    getMyLikedProjects: PropTypes.func.isRequired,
  };

  render() {
    const { loading, projects } = this.props;
    const {
      unsubscribedIds,
      unsubscribedAll,
      mailError,
      confirmResubscribe,
      resubscribing,
      resubscribeError,
    } = this.state;

    return (
      <SupportProjectWrapper>
        <h2 id="supported-projects">Gefolgte Projekte:</h2>
        {unsubscribedAll && (
          <MailNotice>
            <p>
              Über den Abmelde-Knopf deines E-Mail-Programms hast du alle
              Projekt-Updates abbestellt.
            </p>
            <PrimaryButton
              primary={true}
              type="button"
              disabled={resubscribing}
              onClick={() => this.setState({ confirmResubscribe: true })}
            >
              Projekt-Updates wieder erhalten
            </PrimaryButton>
          </MailNotice>
        )}
        {resubscribeError && (
          <MailNote>
            Das hat nicht geklappt. Versuch es in ein paar Minuten noch einmal
            oder <Link to="/contact-us">schreib uns</Link>.
          </MailNote>
        )}
        <ConfirmModal
          open={confirmResubscribe}
          title="Projekt-Updates wieder erhalten?"
          text="Du bekommst wieder E-Mails, wenn Projekte, denen du folgst oder die du unterstützt hast, ein Update veröffentlichen. Für einzelne Projekte kannst du sie danach hier abschalten."
          confirmLabel="Wieder erhalten"
          onCancel={() => this.setState({ confirmResubscribe: false })}
          onConfirm={this.resubscribeAll}
        />
        {mailError && (
          <MailNote>
            Die Einstellung konnte nicht gespeichert werden. Versuch es in ein
            paar Minuten noch einmal.
          </MailNote>
        )}
        <Spin spinning={loading}>
          {projects && projects.length > 0 ? (
            <CardsWrapper>
              {projects.map(
                (project) =>
                  project.name !== 'ramadan2025' &&
                  project.name !== 'ramadan2026' && (
                    <div className="liked-item" key={JSON.stringify(project)}>
                      <Card
                        project={project}
                        footer={
                          <UpdateMailToggle
                            projectName={project.name}
                            checked={
                              !unsubscribedAll &&
                              !unsubscribedIds.includes(project.id)
                            }
                            disabled={unsubscribedAll}
                            onChange={(receive) =>
                              this.toggleMail(project.id, receive)
                            }
                          />
                        }
                      />
                    </div>
                  )
              )}
            </CardsWrapper>
          ) : (
            <SadFaceWrapper>
              <SvgWrapper width={'150px'} height={'auto'}>
                <SadFace />
              </SvgWrapper>
            </SadFaceWrapper>
          )}
        </Spin>
      </SupportProjectWrapper>
    );
  }
}

const mapStateToProps = (state) => {
  const { likedProjects: projects, loading, errors } = state.projects;
  return {
    projects,
    loading,
    errors,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getMyLikedProjects: () => dispatch(ProjectsActions.getMyLikedProjects()),
});

export default connect(mapStateToProps, mapDispatchToProps)(LikedProjects);
